    <p-toast position="bottom-right"></p-toast>
    <p-confirmDialog></p-confirmDialog>
    <app-billing-sidebar>
      <app-report-tasks-table body [transPartKey]="transPartKey" [origins]="origins"></app-report-tasks-table>
    </app-billing-sidebar>

